/**
* Inventory Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Inventory Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'inventory-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.inventory-slider .slider' ).slick( {
        dots: false,
        arrows: false,
        slidesToShow: 3,
        centerMode: true,
        centerPadding: '20vh',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              centerPadding: '20vh',
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerPadding: '10vh',
            },
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              centerPadding: '5vh',
            },
          },
        ],
      } );

      let maxSlideHeight = 0;
      $( '.inventory-slider .slider .slide' ).each( function() {
        if ( $( this ).height() > maxSlideHeight ) {
          maxSlideHeight = $( this ).height();
        }
      } );

      $( '.inventory-slider .slider .slide' ).height( maxSlideHeight );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'inventory-slider', COMPONENT );
} )( app );
